import createVueApp from '@/common/createApp'

Styxie.Initializers.StatsAuditReports = {
  show: async(props) => {
    const { default: AuditReportShow } = await import('@/vue_widgets/audit_reports/show/index.vue')
    createVueApp(AuditReportShow, { props: { ...props, isPublic: true } })
  }
}
